import { SiApple, SiDropbox, SiEvernote, SiGoogledrive, SiGooglekeep, SiNotion, SiObsidian, SiPinterest, SiPocket } from 'react-icons/si';
import fabricIcon from '../assets/images/compare-icons/fabric.png';
import mymindIcon from '../assets/images/compare-icons/mymind.png';
import raindropIcon from '../assets/images/compare-icons/raindrop.png';
import otterIcon from '../assets/images/compare-icons/otter.png';
import voicenotesIcon from '../assets/images/compare-icons/voicenotes.png';
import glaspIcon from '../assets/images/compare-icons/glasp.svg';

const GlaspIcon = ({ size = 20, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M3.73666 72.9829C-1.17604 68.0757 -1.17605 60.1197 3.73658 55.2125L44.259 14.7354L64.026 34.4803L14.6085 83.8425L3.73666 72.9829Z" fill="#FF4E74" />
        <path d="M93.6763 64.0977L44.2592 14.7354L55.131 3.87568C60.0437 -1.03147 68.0087 -1.03148 72.9213 3.87568L113.444 44.3528L93.6763 64.0977Z" fill="#FFF85E" />
        <path d="M64.0262 93.7148L113.444 44.3528L124.315 55.2125C129.228 60.1197 129.228 68.0757 124.315 72.9829L83.7929 113.46L64.0262 93.7148Z" fill="#76FF54" />
        <path d="M72.9212 124.32C68.0086 129.227 60.0436 129.227 55.1309 124.32L14.6085 83.8424L34.3755 64.0977L83.7928 113.46L72.9212 124.32Z" fill="#5C94FF" />
    </svg>
);

const CapacitiesIcon = ({ size = 20, ...props }) => (
    <svg width={size} height={size} viewBox="7.12 7.3 63.41 63.41" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="38.8209" cy="39" r="13.45" transform="rotate(-15 38.8209 39)" fill="currentColor"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M54.7914 66.0811C54.6942 66.3374 54.5105 66.5518 54.271 66.6852C52.0346 67.9311 49.6099 68.9243 47.0245 69.617C30.1152 74.1478 12.7346 64.1131 8.20379 47.2038C3.67296 30.2946 13.7077 12.9139 30.6169 8.38311C33.2023 7.69037 35.7987 7.33813 38.3584 7.2989C38.6325 7.29469 38.8988 7.38849 39.1111 7.56192C41.8794 9.82347 44.4239 12.3787 46.6916 15.197C47.4731 16.1681 46.2983 17.5912 45.101 17.2444C41.2693 16.1343 37.0954 16.023 32.9609 17.1308C20.8828 20.3671 13.7152 32.7819 16.9515 44.8599C20.1878 56.938 32.6025 64.1056 44.6806 60.8693C48.8151 59.7615 52.3742 57.5781 55.1375 54.7009C56.001 53.8018 57.7299 54.4469 57.5387 55.6787C56.9839 59.2532 56.058 62.7384 54.7914 66.0811ZM65.4625 56.1737C64.7914 57.2153 63.3044 56.5354 63.4669 55.307C64.4343 47.9938 64.0074 40.3692 61.9779 32.7952C59.9484 25.2211 56.5058 18.4044 52.0114 12.5547C51.2565 11.5722 52.2043 10.2398 53.3063 10.8064C60.9824 14.7532 67.0278 21.8023 69.4377 30.7963C71.8476 39.7902 70.1368 48.9176 65.4625 56.1737Z" fill="currentColor"/>
    </svg>
);

// Icon glyph/image per competitor. Color and background are theme-specific
// (dark page vs. light page), so those are defined by each consuming view.
export const COMPETITOR_ICONS = {
    'google-keep': { component: SiGooglekeep },
    'apple-notes': { component: SiApple },
    pocket: { component: SiPocket },
    evernote: { component: SiEvernote },
    fabric: { image: fabricIcon },
    mymind: { image: mymindIcon },
    glasp: { component: GlaspIcon, image: glaspIcon },
    notion: { component: SiNotion },
    obsidian: { component: SiObsidian },
    capacities: { component: CapacitiesIcon },
    dropbox: { component: SiDropbox },
    'google-drive': { component: SiGoogledrive },
    pinterest: { component: SiPinterest },
    raindrop: { image: raindropIcon },
    otter: { image: otterIcon },
    voicenotes: { image: voicenotesIcon }
};
